import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import Card from './Card';
import './index.scss';

const source = 'gallery-listing';

const MainContent = ({ items }) => {
    const { isTouch } = getContext();

    return (
        <div className={classNames('main-content', { 'desktop': !isTouch })}>
            {items.map((item, index) => (
                <Card key={index} item={item} source={source}/>))}
        </div>
    );};

MainContent.propTypes = {
    items: PropTypes.array
};

export default MainContent;
